import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const FOMENTAREASTATUS_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.FomentAreaStatus.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const FOMENTAREASTATUS_CONFIG = {
  entityName: 'FomentAreaStatus',
  localizationKey: 'Controlling::Entity.FomentAreaStatus',
  fields: FOMENTAREASTATUS_FIELDS,
  permission: 'ControllingContract.FomentAreaStatuses',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
